import http from '../helpers/http';

const ApprovalComment = (token: string) => {
  const headers = { 'x-access-token': token };

  return {
    list: async (approvalType: string, approvalId: string) => {
      const result = await http.get(`/approval-comments/${approvalType}/${approvalId}`, { headers });
      return result.data.data || [];
    },
    create: async (approvalType: string, approvalId: string, text: string, schoolId?: string) => {
      const result = await http.post(`/approval-comments`, { approvalType, approvalId, text, schoolId }, { headers });
      return result.data.data;
    },
  };
};

export default ApprovalComment;
